import { render, staticRenderFns } from "./mdUserTalk.vue?vue&type=template&id=b8d05ebc&scoped=true&"
import script from "./mdUserTalk.vue?vue&type=script&lang=js&"
export * from "./mdUserTalk.vue?vue&type=script&lang=js&"
import style0 from "./mdUserTalk.vue?vue&type=style&index=0&id=b8d05ebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d05ebc",
  null
  
)

export default component.exports